import labelsComponent from './labels';

export default function labels(picasso) {
  picasso.component('labels', labelsComponent);
}
